import { TransportType } from ".";

import { Session } from "./auth";
import { Device } from "./device";
import { User } from "./users";

export type DriverPermissionStatus = "denied" | "granted" | "restricted";
export type DriverLocationPermission =
  "always" | "denied" | "restricted" | "whileInUse";
export type DriverLocationPrecision = "approximate" | "full";
export type DriverPlatform = "ANDROID" | "IOS";

export type DriverPermissions = {
  appDutyStatus: DutyStatus;
  batteryOptimizationExempt: boolean;
  camera: DriverPermissionStatus;
  deviceModel?: string;
  location: DriverLocationPermission;
  locationPrecision: DriverLocationPrecision;
  microphone: DriverPermissionStatus;
  notification: DriverPermissionStatus;
  platform: DriverPlatform;
  updatedAt?: string;
};

export type DriverEntity = {
  availability: AvailabilitySchedule | null;
  device: Device;
  dutyStatus: DutyStatus;
  equipment: EquipmentTag[];
  id: string;
  label: string;
  licenseNumber: string;
  location: {
    latitude: number;
    longitude: number;
    updatedAt: string;
  } | null;
  operationArea: OperationArea | null;
  permissions: DriverPermissions | null;
  registrationNumber: string;
  routing: string;
  session: Session;
  ssnNumber: string;
  transport: {
    model: string;
    plateNumber: string;
  };
  transportType: TransportType;
  userProfile: User;
  userProfileId: string;
  value: string;
};

export enum DutyStatus {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
  INTRANSIT = "INTRANSIT",
}

export enum DayOfWeek {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}

export type TimeSlot = {
  endTime: string;
  startTime: string;
};

export type DayAvailability = {
  day: DayOfWeek;
  enabled: boolean;
  timeSlots: TimeSlot[];
};

export type AvailabilitySchedule = {
  days: DayAvailability[];
  repeatEndDate: string | null;
};

export enum EquipmentTag {
  CATERING_BAG = "CATERING_BAG",
  PIZZA_BAG = "PIZZA_BAG",
  INSULATED_CONTAINER = "INSULATED_CONTAINER",
  REFRIGERATION_UNIT = "REFRIGERATION_UNIT",
  FRAGILE_HANDLING = "FRAGILE_HANDLING",
}

export const EQUIPMENT_LABELS: Record<EquipmentTag, string> = {
  [EquipmentTag.CATERING_BAG]: "Catering Bag",
  [EquipmentTag.PIZZA_BAG]: "Pizza Bag",
  [EquipmentTag.INSULATED_CONTAINER]: "Insulated Container",
  [EquipmentTag.REFRIGERATION_UNIT]: "Refrigeration Unit",
  [EquipmentTag.FRAGILE_HANDLING]: "Fragile Handling",
};

export type OperationArea = {
  coordinates: { lat: number; lng: number }[];
  type: string;
};

export type DriverLocation = {
  heading: number;
  latitude: number;
  longitude: number;
  updatedAt: string;
};

export type DriverLocationResponse = Record<string, DriverLocation>;
